import PropTypes from 'prop-types';
import React, { isValidElement } from 'react';
import { renderToString } from 'react-dom/server';
import Join from '../Join';
export default function HighLight(_ref) {
  var children = _ref.children,
      keyword = _ref.keyword,
      exact = _ref.exact;

  if (keyword) {
    if ( /*#__PURE__*/isValidElement(children)) {
      children = renderToString(children);
    }

    children = String(children);

    if (exact) {
      // 精确匹配
      return keyword === children ? /*#__PURE__*/React.createElement("span", {
        className: "jmtd-highlight"
      }, children) : children;
    }

    return /*#__PURE__*/React.createElement(Join, {
      separator: /*#__PURE__*/React.createElement("span", {
        className: "jmtd-highlight"
      }, keyword)
    }, children.split(keyword));
  }

  return children;
}
HighLight.propTypes = {
  id: PropTypes.string,
  keyword: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  exact: PropTypes.bool
};
HighLight.defaultProps = {
  id: null,
  keyword: '',
  children: '',
  exact: false
};